import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EditableEvent } from 'types/event.types';

import { BaseEventFragment } from './common';

const EditableEventQuery = gql`
  query EditableEventQuery($id: Int!) {
    event(id: $id) {
      ...BaseEventFragment
    }
  }
  ${BaseEventFragment}
`;

export type EditableEventQueryResult = {
  event: EditableEvent;
};

export const getEvent = (id: number): Promise<EditableEventQueryResult> => {
  if (!id || id <= 0) {
    throw new Error('Invalid event ID provided');
  }

  return gqlClient.request<EditableEventQueryResult>(EditableEventQuery, { id });
};
